import React from 'react';
import { propEq } from 'ramda';

import { HiddenContainer } from '@components/PLP/hiddenContainer';
import { ArtworkCard } from '@components/artworkCard';
import { renderWhenOtherwise } from '@utils/rendering';
import { PRODUCT_TYPE } from '@utils/constants';
import { Artwork, IMAGE_URL_TYPE } from '@definitions/artworks.types';
import { GiftCertificateCard } from '@components/giftCertificateCard';

import { GridList, GridItem, imageStyles, GridWrapper } from './smallGrid.styles';

export interface SmallGridProps {
  artworks: Artwork[];
}

export const SmallGrid = ({ artworks }: SmallGridProps) => {
  const renderArtwork = renderWhenOtherwise(
    propEq('type', PRODUCT_TYPE.PRODUCT),
    (artwork) => (
      <GridItem>
        <ArtworkCard
          artwork={artwork}
          imageStyles={imageStyles}
          imageUrlType={IMAGE_URL_TYPE.URL_THUMBNAIL}
          withSlickSlider
        />
      </GridItem>
    ),
    (giftCertificate) => (
      <GridItem>
        <GiftCertificateCard imageStyles={imageStyles} giftCertificate={giftCertificate} smallCard />
      </GridItem>
    )
  );

  return (
    <GridList>
      {artworks.map((product, index) => (
        <GridWrapper key={index}>
          <HiddenContainer index={index} />
          {renderArtwork(product)}
        </GridWrapper>
      ))}
    </GridList>
  );
};
